.container {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 50%;
  border-left: 1px var(--content-border-color) solid;
  display: flex;
  flex-direction: column;
  background-color: var(--app-background);
  z-index: 1000;
  box-shadow: 0 0.4rem 0.4rem rgba(0, 0, 0, 0.25);

  &[data-insideStep='true'] {
    top: 4rem;
  }
}

.detail {
  overflow-y: auto;
  padding: 1.6rem;
}
